module.exports = __webpack_public_path__ + "img/item5.5512b0c0.png";